<template>
    <div class="container">
        <div class="col-md-12 mt-3">
            <h2> {{ labels.title }} </h2>
        </div>
        <div class="row mt-5">
            <div class="col-md-6 d-flex justify-content-end align-items-center">
                <h4>{{ labels.fecha }}</h4>
            </div>
            <div class="col-md-2 d-flex justify-content-start pl-0">
                <!-- <input type="month" v-model="fecha" class="form-control" style="width: 180px;"> -->
                <select v-model="fecha" class="form-control">
                    <option value="">{{ labels.seleccion }}</option>
                    <option v-for="item in lstFechaCierre" :key="item.id" :value="item.fecha_cierre"> {{ item.fecha_cierre }} </option>
                </select>
            </div>
        </div>
        <div class="col-md-12 mt-4">
            <b-button type="button" id="create-btn" @click="consulReportPorContrato">{{ labels.consultar }}</b-button>
        </div>
        <div class="row col-md-12 justify-content-center" v-if="lstReporContrato != 0">
            <div v-if="btnGenExcel" class="row col-md-12 d-flex justify-content-end">
                <md-button style="background-color: #2e507a; width: 40px; height: 40px;" class="md-fab md-primary" @click="genReportePorContrato()">
                    <md-icon>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path fill="#ffffff" d="M192 112L304 112L304 200C304 239.8 336.2 272 376 272L464 272L464 512C464 520.8 456.8 528 448 528L192 528C183.2 528 176 520.8 176 512L176 128C176 119.2 183.2 112 192 112zM352 131.9L444.1 224L376 224C362.7 224 352 213.3 352 200L352 131.9zM192 64C156.7 64 128 92.7 128 128L128 512C128 547.3 156.7 576 192 576L448 576C483.3 576 512 547.3 512 512L512 250.5C512 233.5 505.3 217.2 493.3 205.2L370.7 82.7C358.7 70.7 342.5 64 325.5 64L192 64zM291.2 329.6C283.2 319 268.2 316.8 257.6 324.8C247 332.8 244.8 347.8 252.8 358.4L290 408L252.8 457.6C244.8 468.2 247 483.2 257.6 491.2C268.2 499.2 283.2 497 291.2 486.4L320 448L348.8 486.4C356.8 497 371.8 499.2 382.4 491.2C393 483.2 395.2 468.2 387.2 457.6L350 408L387.2 358.4C395.2 347.8 393 332.8 382.4 324.8C371.8 316.8 356.8 319 348.8 329.6L320 368L291.2 329.6z"/></svg>
                    </md-icon>
                </md-button>
            </div>
            <b-table
                :items="lstReporContrato"
                :fields="fields"
                hover
                bordered
                responsive
                sticky-header="500px"
                small
                class="tblEstandar"
                head-variant="custom-blue"
                :per-page="perPage"
                :current-page="currentPage"
            >
                <template #cell(total_valor_canon)="data">
                    <div class="text-right">{{ formatNumber(data.item.total_valor_canon) }}</div>
                </template>
                <template #cell(pasivo_inicial)="data">
                    <div class="text-right">{{ formatNumber(data.item.pasivo_inicial) }}</div>
                </template>
                <template #cell(total_cambio_pasivo)="data">
                    <div class="text-right">{{ formatNumber(data.item.total_cambio_pasivo) }}</div>
                </template>
                <template #cell(total_pago_capital)="data">
                    <div class="text-right">{{ formatNumber(data.item.total_pago_capital) }}</div>
                </template>
                <template #cell(total_intereses)="data">
                    <div class="text-right">{{ formatNumber(data.item.total_intereses) }}</div>
                </template>
                <template #cell(pasivo_final)="data">
                    <div class="text-right">{{ formatNumber(data.item.pasivo_final) }}</div>
                </template>
                <template #cell(activo_derecho_uso_bruto)="data">
                    <div class="text-right">{{ formatNumber(data.item.activo_derecho_uso_bruto) }}</div>
                </template>
                <template #cell(total_gasto_amortizacion)="data">
                    <div class="text-right">{{ formatNumber(data.item.total_gasto_amortizacion) }}</div>
                </template>
                <template #cell(amortizacion_acumulada)="data">
                    <div class="text-right">{{ formatNumber(data.item.amortizacion_acumulada) }}</div>
                </template>
            </b-table>
            <div class="row col-12 mt-1">
                <div class="col-10 d-flex justify-content-center">
                    <b-pagination
                    v-model="currentPage"
                    :total-rows="lstReporContrato.length"
                    :per-page="perPage"
                    align="center"
                    size="md"
                    class="custom-pagination"
                    ></b-pagination>
                </div>
                <div class="col-2 d-flex justify-content-end">
                    <label class="mr-2 mb-0">Filas por página:</label>
                    <b-form-select
                    v-model="perPage"
                    :options="[5, 10, 20, 50, 100, 500]"
                    size="sm"
                    style="width: 80px;"
                    ></b-form-select>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ContratoCierre from '../../services/ContratoCierre';
import Reportes from '../../services/Reportes';
import Authentication from "../../services/Authentication";
import * as XLSX from "exceljs";

export default {
    name : 'ReportePorContrato',
    data : () => ({
        fecha : '',
        nameCompania : '',
        lstReporContrato : [],
        lstFechaCierre : [],
        perPage: 500,
        currentPage: 1,
        fields: [
            { key: 'identificacion', label: 'Nit', sortable: false },
            { key: 'nombre', label: 'Arrendador', sortable: false },
            { key: 'nro_contrato', label: 'Contrato', sortable: false },
            { key: 'total_valor_canon', label: 'Total valor canon', sortable: false },
            { key: 'pasivo_inicial', label: 'Pasivo inicial', sortable: false },
            { key: 'total_cambio_pasivo', label: 'Total cambio pasivo', sortable: false },
            { key: 'total_pago_capital', label: 'Total pago capital', sortable: false },
            { key: 'total_intereses', label: 'Total intereses', sortable: false },
            { key: 'pasivo_final', label: 'Pasivo final', sortable: false },
            { key: 'activo_derecho_uso_bruto', label: 'Activo derecho uso bruto', sortable: false },
            { key: 'total_gasto_amortizacion', label: 'Total gasto amortización', sortable: false },
            { key: 'amortizacion_acumulada', label: 'Amortización acumulada', sortable: false },
        ]
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){
                return {
                    title : 'Reporte por contrato',
                    fecha : 'Fecha:',
                    consultar : 'Consultar',
                    nit : 'Nit',
                    arrendador : 'Arrendador',
                    cantidad : 'Cantidad',
                    totValorCanon : 'Total valor canon',
                    pasivoInicial : 'Pasivo inicial',
                    totCambioPasiv : 'Total cambio pasivo',
                    totPagoCapital : 'Total pago capital',
                    totIntereses : 'Total intereses',
                    pasivoFin : 'Pasivo final',
                    actiDerUsoBrt : 'Activo derecho uso bruto',
                    totGastoAmort : 'Total gasto amortización',
                    seleccion : 'Seleccione...'
                }
            }else{
                return {
                    title : 'Contract report',
                    fecha : 'Date:',
                    consultar : 'Consult',
                    nit : 'Nit',
                    arrendador : 'Lessor',
                    cantidad : 'Quantity',
                    totValorCanon : 'Total canon value',
                    pasivoInicial : 'Initial liabilities',
                    totCambioPasiv : 'Total passive change',
                    totPagoCapital : 'Total capital payment',
                    totIntereses : 'Total interests',
                    pasivoFin : 'Final passive',
                    actiDerUsoBrt : 'Asset right gross use',
                    totGastoAmort : 'Total amortization expense',
                    seleccion : 'Select...'
                }
            }
        }
    },
    methods:{
        formatNumber(value){
            return new Intl.NumberFormat('es-CO', { minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(value);
        },
        consulReportPorContrato(){
            if(this.fecha == ''){
                this.$toast.error('Diligenciar la fecha.')
            
            }else{

                Reportes.generaReportePorContrato(this.fecha)
                .then((res) => {
                    // console.log(res.data);
                    this.lstReporContrato = res.data.lstReporContrato

                    if(this.lstReporContrato.length != 0){
                        this.btnGenExcel = true
                    }else{
                        this.btnGenExcel = false
                        this.$toast.error('No hay datos para la fecha.')
                    }
                })
                .catch((error) => {
                    console.log(error);
                    if (error.response.status === 500) {
                        this.$toast.error(error.response.data.message);
                    } 
                })
            }
        },
        async genReportePorContrato(){
            const {Workbook} = XLSX
            const workbook = new Workbook()
            const worksheet = workbook.addWorksheet("Reporte  por contrato "+this.fecha)

            const titulo = ["Reporte por contrato "+this.fecha]
            worksheet.addRow(titulo)
            worksheet.mergeCells('A1:L1')
            worksheet.getCell('A1').font = { name: 'Arial', bold : true, size : 12};
            worksheet.getCell('A1').alignment = { horizontal : 'center'};

            // =======================
            // FILA 2
            // =======================
            worksheet.addRow(['']);
            worksheet.mergeCells('A2:L2');

            const cell2 = worksheet.getCell('A2');

            cell2.value = {
                richText: [
                    { text: 'Generado por: ', font: { bold: true } },
                    { text: `${this.$store.state.userName} | ` },

                    { text: 'Fecha generación: ', font: { bold: true } },
                    { text: `${this.fechaActual()} | ` },

                    { text: 'Compañía: ', font: { bold: true } },
                    { text: `${this.nameCompania}` },
                ]
            };

            cell2.font = { name: 'Arial', size: 12 };
            cell2.alignment = { horizontal: 'center', vertical: 'middle' };

            worksheet.addRow(['']);
            worksheet.mergeCells('A3:L3')

            const tituloCelda = [
                'Nit',
                'Nombre',
                'Contrato',
                'Total valor canon',
                'Pasivo inicial',
                'Total cambio pasivo',
                'Total pago capital',
                'Total intereses',
                'Pasivo final',
                'Activo derecho uso bruto',
                'Total gasto amortización',
                'Amortización acumulada'
            ]

            const headerRow = worksheet.addRow(tituloCelda)
            headerRow.font = { name: 'Arial', bold: true, size: 12 };
            headerRow.alignment = { horizontal: 'center' }

            this.lstReporContrato.map((e) => {
                worksheet.addRow([
                    e.identificacion,
                    e.nombre,
                    e.nro_contrato,
                    this.formatNumber(e.total_valor_canon),
                    this.formatNumber(e.pasivo_inicial),
                    this.formatNumber(e.total_cambio_pasivo),
                    this.formatNumber(e.total_pago_capital),
                    this.formatNumber(e.total_intereses),
                    this.formatNumber(e.pasivo_final),
                    this.formatNumber(e.activo_derecho_uso_bruto),
                    this.formatNumber(e.total_gasto_amortizacion),
                    this.formatNumber(e.amortizacion_acumulada),
                ])
            })

            //Poner borde
            const border = {
                top : {style : 'thin'},
                left : {style : 'thin'},
                bottom : {style : 'thin'},
                right : {style : 'thin'},
            }

            for( let row = 1; row <= worksheet.rowCount; row++){
                if ([1, 2, 3].includes(row)) continue; // 👈 omitir filas
                for( let col = 1; col <= worksheet.columnCount; col++){
                    worksheet.getCell(row, col).border = border;
                }
            }
            //------

            const file = await workbook.xlsx.writeBuffer()
            const downloadLink = document.createElement("a")
            downloadLink.download = "Reporte por contrato.xlsx"
            downloadLink.href = window.URL.createObjectURL(
                new Blob([file], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                })
            )

            downloadLink.style.display = "none";

            document.body.appendChild(downloadLink);
            downloadLink.click();

            downloadLink.remove();
        },
        fechaActual(){
            const fecha = new Date()

            const año = fecha.getFullYear()
            const mes = String(fecha.getMonth() + 1).padStart(2, '0') // getMonth() va de 0 a 11
            const dia = String(fecha.getDate()).padStart(2, '0')

            return `${año}-${mes}-${dia}`
        },
    },
    mounted(){
        ContratoCierre.getListadoFechas()
        .then((res) => {
            // console.log(res.data.lstFechaCierre);
            this.lstFechaCierre = res.data.lstFechaCierre
        })
        .catch((err) => console.log(err))

        Authentication.leaParametros()
        .then ((result) => {
            this.nameCompania = result.data.parametros.compania
        })
        .catch((err) => console.log(err))
    },
    watch:{
        fecha(val){
            if(val == ""){
                this.lstReporContrato = []
            }
        }
    }
}
</script>

<style>

</style>